import {
	type OrderImportDto,
	postOrdersMarketMarketIdVerticalVerticalIdImportCsvPrice,
} from "Infrastructure/Api/Api";
import { processResponse } from "Infrastructure/Api/ApiUtils";
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

export const useImportOrdersPriceMutation = (
	marketId: number,
	_verticalId: number,
) => {
	return useMutation({
		mutationFn: processResponse((data: OrderImportDto) =>
			postOrdersMarketMarketIdVerticalVerticalIdImportCsvPrice(
				data,
				marketId,
				// verticalId,
			),
		),
		onError: (error) => {
			console.error("There was error during upload", error);
		},
		onSuccess: () => {
			toast.success("Upload has been successfull");
		},
	});
};
